import { render, staticRenderFns } from "./shopee-logs.vue?vue&type=template&id=b42efb0a&"
import script from "./shopee-logs.vue?vue&type=script&lang=js&"
export * from "./shopee-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports